// JRV Translines Production & Development API Base Paths
// Priority: window.env (runtime CWP config) -> process.env.REACT_APP_* (build-time config) -> defaults

const getRuntimeOrEnv = (key, defaultVal) => {
  if (typeof window !== "undefined" && window.env && window.env[key]) {
    return window.env[key];
  }
  if (process.env && process.env[key]) {
    return process.env[key];
  }
  return defaultVal;
};

const defaultBase = process.env.NODE_ENV === "development"
  ? "http://localhost:4300"
  : "https://jrv.api.databin.in";

export const BASE_PATH = getRuntimeOrEnv("REACT_APP_BASE_PATH", defaultBase);
export const API_BASE_PATH_MASTER = getRuntimeOrEnv("REACT_APP_API_BASE_PATH_MASTER", `${BASE_PATH}/api/master`);
export const API_BASE_PATH_TRANSACTIONS = getRuntimeOrEnv("REACT_APP_API_BASE_PATH_TRANSACTIONS", `${BASE_PATH}/api/transactions`);
export const API_BASE_PATH_USER = getRuntimeOrEnv("REACT_APP_API_BASE_PATH_USER", `${BASE_PATH}/api/user`);
export const BILLS_PATH = getRuntimeOrEnv("REACT_APP_BILLS_PATH", `${BASE_PATH}/bills/`);
export const PR_PATH = getRuntimeOrEnv("REACT_APP_PR_PATH", `${BASE_PATH}/payment-receipts/`);

